exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn {\n\tfont-weight: bold;\n}\n\n.hover-button-container .hover-button {\n\tvisibility: hidden;\n}\n\n.hover-button-container:hover .hover-button {\n\tvisibility: visible;\n}\n", ""]);

// exports
